

import { TableBody, TableCell, TableHead, TableRow, Grid, Typography, Button } from "@mui/material";
import { LayoutTabla } from "../../layouts";
import { fechaSinHora } from "../../../helpers/prepararFecha";





export const InformacionItemXId = ({ data }) => {


    return (
        <Grid container sx={{ justifyContent:'center', display:'flex', mb:3 }}>
            {( data ) &&
            <LayoutTabla>
                <TableHead>
                    <tr><TableCell sx={{backgroundColor:'secondary.main'}} colSpan={4}>INFORMACIÓN DE CLIENTE</TableCell></tr>
                </TableHead>
                <TableHead >
                    <TableRow>
                        <TableCell>Fecha Compra</TableCell>
                        <TableCell>Nombre Cliente</TableCell>
                        <TableCell>Movil</TableCell>
                        <TableCell>Direccion</TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    <TableRow >
                        <TableCell>{ fechaSinHora(data?.op?.startOp) }</TableCell>
                        <TableCell>{ data?.op?.quienCompra?.nombre }</TableCell>
                        <TableCell>{ data?.op?.quienCompra?.movil  }</TableCell>
                        <TableCell>{ data?.op?.quienCompra?.direccion  }</TableCell>
                    </TableRow>
                </TableBody>
            </LayoutTabla>
            }


            {/* {(data) &&
            <LayoutTabla mt={3}>
                <TableHead>
                    <tr>
                        <TableCell sx={{backgroundColor:'secondary.main'}} colSpan={3}>DETALLES DEL ITEM EN PRODUCCIÓN</TableCell>
                    </tr>
                </TableHead>

                <TableHead >
                    <TableRow>
                        <TableCell>Colaborador</TableCell>
                        <TableCell>Area de Trabajo</TableCell>
                        <TableCell>Trabajando</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow >
                        <TableCell>
                            {
                            ( !data.colaborador ) 
                            ? ( <span className="nocomenzo">No Tiene</span> )
                            : ( <span>{ data.colaborador.nombre }</span> )
                            }
                        </TableCell>
                        <TableCell>
                            <Typography variant='h5'>{ data.area }</Typography>    
                        </TableCell>
                        <TableCell>
                            { 
                            ( !data.produccion )
                            ?<Button variant="contained" color="primary">
                                Disponible
                            </Button>
                            :<Button variant="contained" color="info">
                                En Trabajo
                            </Button> 
                            }
                        </TableCell>
                    </TableRow>
                </TableBody>
            </LayoutTabla>
            } */}
        </Grid>
    )
}
